


export class VendorDataAniel {
  "vendorAccountNumber";
  "countryKey";
  "name1";
  "name2";
  "city";
  "district";
  "poBox";
  "poBoxPostalCode";
  "postalCode";
  "region";
  "sortField";
  "houseNumberAndStreet";
  "taxNumber1";
  "taxNumber2";
  "firstTelephoneNumber";
  "secondTelephoneNumber";
  "taxNumber3";
  "taxNumber4";
  "purchasingBlock";
  "deleteFlag";
  "internetMailAddress";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VendorDataAniel`.
   */
  static getModelName() {
    return "VendorDataAniel";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VendorDataAniel for dynamic purposes.
  **/
  static factory(data) {
    return new VendorDataAniel(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'VendorDataAniel',
      plural: 'VendorDataAniels',
      path: 'VendorDataAniels',
      properties: {
        "vendorAccountNumber": {
          name: 'vendorAccountNumber',
          type: 'string'
        },
        "countryKey": {
          name: 'countryKey',
          type: 'string'
        },
        "name1": {
          name: 'name1',
          type: 'string'
        },
        "name2": {
          name: 'name2',
          type: 'string'
        },
        "city": {
          name: 'city',
          type: 'string'
        },
        "district": {
          name: 'district',
          type: 'string'
        },
        "poBox": {
          name: 'poBox',
          type: 'string'
        },
        "poBoxPostalCode": {
          name: 'poBoxPostalCode',
          type: 'string'
        },
        "postalCode": {
          name: 'postalCode',
          type: 'string'
        },
        "region": {
          name: 'region',
          type: 'string'
        },
        "sortField": {
          name: 'sortField',
          type: 'string'
        },
        "houseNumberAndStreet": {
          name: 'houseNumberAndStreet',
          type: 'string'
        },
        "taxNumber1": {
          name: 'taxNumber1',
          type: 'string'
        },
        "taxNumber2": {
          name: 'taxNumber2',
          type: 'string'
        },
        "firstTelephoneNumber": {
          name: 'firstTelephoneNumber',
          type: 'string'
        },
        "secondTelephoneNumber": {
          name: 'secondTelephoneNumber',
          type: 'string'
        },
        "taxNumber3": {
          name: 'taxNumber3',
          type: 'string'
        },
        "taxNumber4": {
          name: 'taxNumber4',
          type: 'string'
        },
        "purchasingBlock": {
          name: 'purchasingBlock',
          type: 'string'
        },
        "deleteFlag": {
          name: 'deleteFlag',
          type: 'string'
        },
        "internetMailAddress": {
          name: 'internetMailAddress',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/VendorDataAniel.js